import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { useSiteContent } from "@/hooks/useContent";

export default function WhatsAppButton() {
  const { content } = useSiteContent();
  const wa = content?.settings?.whatsapp || "919153020904";

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      <motion.a
        href={`tel:+${wa}`}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2.3, type: "spring", stiffness: 200 }}
        whileHover={{ scale: 1.15, rotate: 10 }}
        whileTap={{ scale: 0.9 }}
        className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-lg hover:shadow-xl hover:shadow-white/20 transition-shadow duration-300"
        data-testid="call-floating-button"
        title="Call Now"
      >
        <Phone size={22} className="text-gg-black" />
      </motion.a>
      <motion.a
        href={`https://wa.me/${wa}`}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2, type: "spring", stiffness: 200 }}
        whileHover={{ scale: 1.15, rotate: -10 }}
        whileTap={{ scale: 0.9 }}
        className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-xl shadow-green-500/30 wa-pulse hover:shadow-green-500/50 transition-shadow duration-300"
        data-testid="whatsapp-floating-button"
        title="Chat on WhatsApp"
      >
        <MessageCircle size={26} className="text-white" />
      </motion.a>
    </div>
  );
}
